import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { FETCH_ALL_CHEMICALS } from 'api/activity';
import {
  BannerComponent,
  Button,
  Card,
  Checkbox,
  LevelNav,
  Modal,
} from 'common/components';
import { ChemicalForm } from 'containers';

class ChemicalsForm extends PureComponent {
  state = {
    active: null,
    modal: false,
  };

  toggleModal = chemical => {
    const { changeValue, selectedChemicals, onSubmit } = this.props;
    this.setState({ modal: !this.state.modal });

    // when chemical object reponse exists, update chemicals form value
    if (chemical && chemical.name) {
      const chemicals = (selectedChemicals || []).concat([
        JSON.stringify(chemical),
      ]);
      changeValue('chemicals', chemicals);
      onSubmit();
    }
  };

  render() {
    const { onSubmit, chemicals } = this.props;

    return (
      <Fragment>
        <BannerComponent
          theme={['static', 'strong', 'large', 'mobile-fixed']}
          message={
            <LevelNav
              nav={{
                left: {
                  label: <span className={'visible--desktop'}>Back</span>,
                  action: () => onSubmit(),
                },
                center: { label: 'Select Chemical' },
              }}
            />
          }
        />

        <form onSubmit={onSubmit}>
          {chemicals && chemicals.length === 0 && (
            <p className={'text--center text--medium'}>
              You have not added any chemicals yet, please start by adding a
              chemical.
            </p>
          )}

          {chemicals && chemicals.length > 0 && (
            <Fragment>
              <p className={'text--fade'}>
                <small>Select a chemical from the list below to add.</small>
              </p>

              <div className={'field'}>
                {chemicals && (
                  <Checkbox
                    name={'chemicals'}
                    theme={['card']}
                    onChange={onSubmit}
                    options={chemicals.map(chemical => {
                      const { name, brand, type } = chemical;
                      return {
                        value: JSON.stringify({ ...chemical }),
                        label: (
                          <Card footer={type}>
                            <h3 className="cardlist__title">{name}</h3>
                            {brand && (
                              <p className="cardlist__chemicals cardlist__chemicals--brand">
                                {brand}
                              </p>
                            )}
                          </Card>
                        ),
                      };
                    })}
                  />
                )}
              </div>
            </Fragment>
          )}
        </form>

        <Button
          className="btn btn--secondary btn--add"
          onClick={() => this.toggleModal()}
        >
          <span className={'visible--desktop'}>Add Chemical</span>
        </Button>

        {this.state.modal && (
          <Modal
            enableTopRightClose
            theme={['narrow']}
            onToggle={this.toggleModal}
          >
            <ChemicalForm closeForm={this.toggleModal} />
          </Modal>
        )}
      </Fragment>
    );
  }
}

ChemicalsForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  // from mapstat
  selectedChemicals: PropTypes.array,
  // from dispatch
  changeValue: PropTypes.func.isRequired,

  // manually added
  onSubmit: PropTypes.func.isRequired,
  // graphql list
  chemicals: PropTypes.arrayOf(PropTypes.object),
};

const formSettings = {
  form: 'activityform',
  destroyOnUnmount: false,
};
const field = formValueSelector(formSettings.form);
const mapState = state => ({
  selectedChemicals: field(state, 'chemicals'),
});
const mapDispatch = dispatch => ({
  changeValue: (fieldname, value) =>
    dispatch(change(formSettings.form, fieldname, value)),
});

export default compose(
  graphql(FETCH_ALL_CHEMICALS, {
    options: () => ({
      fetchPolicy: 'cache-and-network',
    }),
    props: props => {
      const {
        data: { getAllChemicals },
      } = props;
      return {
        chemicals: getAllChemicals.sort((a, b) => a.name.localeCompare(b.name)),
        ...props,
      };
    },
  }),
  reduxForm(formSettings),
  connect(
    mapState,
    mapDispatch
  )
)(ChemicalsForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Chemicals.js